module.exports = {
  nodeEnv: process.env.VUE_APP_ENV,
  baseApi: process.env.VUE_APP_BASE_API,
  graphqlHttp: process.env.VUE_APP_GRAPHQL_HTTP,
  graphqlHttpPublic: process.env.VUE_APP_GRAPHQL_HTTP_PUBLIC,
  graphqlBase: process.env.VUE_APP_GRAPHQL_BASE,
  analyticsId: process.env.VUE_APP_ANALYTICS_ID,
  sentryDsn: process.env.VUE_APP_SENTRY_DSN
}
